import script from "./DeepSeekResult.vue?vue&type=script&setup=true&lang=js"
export * from "./DeepSeekResult.vue?vue&type=script&setup=true&lang=js"

import "./DeepSeekResult.vue?vue&type=style&index=0&id=0c6c5f1a&lang=scss"

const __exports__ = script;

export default __exports__